import { render, staticRenderFns } from "./CAJG1110.vue?vue&type=template&id=fef293e0&scoped=true"
import script from "./CAJG1110Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAJG1110Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAJG1110.vue?vue&type=style&index=0&id=fef293e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef293e0",
  null
  
)

export default component.exports